import Logger from '../../utils/logger';
import {
  isFullScreenMode,
  toggleFullScreen,
  onFullScreenChange,
  offFullScreenChange,
} from './utils';

export default class FullscreenService {
  _player = null;
  _isFullScreen = false;

  constructor(player) {
    this._player = player;
  }

  start() {
    onFullScreenChange(this._player.playerElement, this._syncPlayerState);
    Logger.debug('Fullscreen service: started');
  }

  stop() {
    offFullScreenChange(this._player.playerElement, this._syncPlayerState);
    Logger.debug('Fullscreen service: stopped');
  }

  toggleFullScreen() {
    toggleFullScreen(this._player.fullScreenContainer, this._player.playerElement, this._isFullScreen);
  }

  isFullScreen() {
    return isFullScreenMode();
  }

  _syncPlayerState = (e) => {
    let isFullscreen;
    if (e.type === 'webkitbeginfullscreen') {
      // on iOS we need to call webkitEnterFullscreen method to show full screen.
      // we need to listen to webkitbeginfullscreen to know if it is currently in full screen mode
      isFullscreen = true;
    } else if (e.type === 'webkitendfullscreen') {
      // on iOS we need to call webkitEnterFullscreen method to show full screen.
      // we need to listen to webkitendfullscreen to know if it is currently no longer in full screen mode
      isFullscreen = false;
    } else {
      isFullscreen = isFullScreenMode();
    }
    this._isFullScreen = isFullscreen;
    Logger.debug(`Fullscreen service: player ${isFullscreen ? 'is' : 'is not'} fullscreen`);
    this._player.model = this._player.model.merge({ isFullscreen });
    this._player.dispatchEvent('fullscreen', { isFullscreen });
  }
}
